import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {filter, take, tap} from 'rxjs/operators';
import { EmailConnectionEntity } from '../entities/email-connection.entity';
import { State } from '../State';
import { ResolverLoadEmailConnections } from '../State/actions/resolver.actions';

@Injectable({
    providedIn: 'root'
})
export class EmailConnectionResolver
    implements Resolve<EmailConnectionEntity[]> {
    constructor(private store: Store<State>) {
    }

    resolve() {
        const value$ = this.store.select(state => state.emailConnections.emailConnections);

        value$
            .pipe(
                filter(value => !value),
                take(1),
                tap(() => {
                        if (localStorage.getItem('token') != null) {
                            this.store.dispatch(new ResolverLoadEmailConnections());
                        }
                    }
                )
            )
            .subscribe();

        return value$.pipe(
            filter(value => !!value),
            take(1)
        );
    }
}
